import React from 'react'
import PropTypes from 'prop-types'

const AnchorHeader = React.forwardRef((props, ref) => (
  <h2 className="legal__heading heading-form" ref={ref}>
    {props.title}
  </h2>
))

AnchorHeader.displayName = 'AnchorHeader'

AnchorHeader.propTypes = {
  title: PropTypes.string.isRequired
}

export default AnchorHeader
